module.exports = __webpack_public_path__ + "assets/img/01-l.d4d3a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/01-l.jpg
// module id = jWbr
// module chunks = 0